module.exports = __webpack_public_path__ + "media/vid-ig.d03f9543.webm";